
<marv-input-date label="{{ 'START_DATE' | translate }}" formName="startDate" [withSpeechToText]="true"/>
<marv-input-date label="{{ 'END_DATE' | translate }}" formName="endDate" [withSpeechToText]="true"/> 
<app-type-mission-select label="{{ 'TYPES_MISSIONS' | translate }}" formName="typesMissionsCodes" [withSpeechToText]="true" [multiple]="true" />    
<app-operation-select label="{{ 'OPERATIONS' | translate }}" formName="operationsIds" [startDate]="this.startDate" [endDate]="this.endDate" [withSpeechToText]="true" [multiple]="true" (onChangeItems)="this.onChangeOperationsItems($event)"/>    

@if(!this.hideFiltersStore){
    <app-area-select label="{{ 'AREAS' | translate }}" formName="areasIds" [withSpeechToText]="true" [multiple]="true" />
    <app-sector-select label="{{ 'SECTORS' | translate }}" formName="sectorsIds" [sectors]="this.sectors" [withSpeechToText]="true" [multiple]="true" />
    <app-retailer-select label="{{ 'RETAILERS' | translate }}" #retailerSelect formName="retailersCodes" [withSpeechToText]="true" [multiple]="true"/>    
    <app-store-select label="{{ 'STORES' | translate }}" #storeSelect formName="storesCodes" [stores]="this.stores" [withSpeechToText]="true" [multiple]="true" />    
    <marv-input type="text" label="{{ 'CITY' | translate }}" icon="business-outline" formName="city" [showBtnClearInput]="true" [withSpeechToText]="true"/>
}
    
<marv-input type="text" label="{{ 'TAGS' | translate }}" icon="bookmarks-outline" formName="keywords" [showBtnClearInput]="true" [withSpeechToText]="true"/>

@if(this.isFetchingInstantPhotoFilterTags){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else{
    @if(this.instantPhotoFilterTags.length > 0){
        <marv-section-title label="{{'QUICK_FILTERS' | translate}}" />    
        <div id="instant_photo_filter_tags">
            @for(instantPhotoFilterTag of this.instantPhotoFilterTags; track $index){
                <marv-checkbox label="{{ instantPhotoFilterTag.tag | translate }} ({{(instantPhotoFilterTag.counter ? instantPhotoFilterTag.counter : 0)}})" [formName]="'instantPhotoFilterTag_'+$index" labelPlacement="end"/> 
            }
        </div>
    }
}